
<div
	*ngFor="let event of subscribedEvents"
	class="event"
	[routerLink]="[ '/Veranstaltungen/visualisieren' ]"
	[queryParams]="{ id: event.id }"
>
	{{event.name}}
</div>

<div
	*ngIf="!bLoading && !subscribedEvents.length"
	class="noElements"
>
	Keine abonnierten Veranstaltungen
</div>